import * as React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Bar } from './SideBar.styles'
import { Notifications } from '../..'
import { Link } from 'react-router-dom'
import {
    dashboard,
    fixtures,
    content,
    stores,
    userProfile,
} from '../../../containers/Landing/LandingIconsWhite'
import { getDashboards, getSelectedEstateId } from '../../../reducers/app'
import { EstateUtils } from '../../../utils'
import { useSize } from '../../utils'
import { ACL, Routes } from '../../../constants'
import { useAppSelector } from '../../../reducers'
import WhiteSelfServe from '../icons/Icon-Self-Serve-White.png'

const SideBar = ({ flashMessages, fullscreen, messages, onDismiss, onDismissAll, onDismissFlash }) => {
    const estate = useAppSelector(getSelectedEstateId)
    const [display, setDisplay] = React.useState(false)
    const { isMobile } = useSize()
    const { t } = useTranslation()
    const hasAnyDashboard = useAppSelector(state => getDashboards(state).length > 0)
    const hasAccessToSelfServe = useAppSelector(
        (state) => EstateUtils.hasPermission(state, { acls: [ACL.VIEW_SELF_SERVE] }, { ignoreAdmin: true }),
    )

    if (isMobile) {
        return null;
    }

    const dashboardPath = Routes.buildRoute(Routes.REPORTING_DASHBOARDS, { estate })
    const estateListPath = Routes.buildRoute(Routes['ESTATE:LIST'], { estate })
    const contentPath = Routes.buildRoute(Routes.CONTENT, { estate })
    const mediaPath = Routes.buildRoute(Routes['CONTENT:MEDIA'], { estate })
    const selfServePath = Routes.buildRoute(Routes.SELF_SERVE, { estate })

    return (
        <Bar
            fullscreen={fullscreen}
            className="sidebar"
            onMouseEnter={() => setDisplay(true)}
            onMouseLeave={() => setDisplay(false)}
        >
            <div className="sidebar-images">
                <Link className="sidebar-link-image" to={estateListPath}>
                    <img src={stores} alt="stores icon"></img>
                </Link>
                <Link className="sidebar-link-image" to={contentPath}>
                    <img src={fixtures} alt="fixtures icon"></img>
                </Link>
                <Link className="sidebar-link-image" to={mediaPath}>
                    <img src={content} alt="content icon"></img>
                </Link>
                {hasAccessToSelfServe && (
                    <Link className="sidebar-link-image" to={selfServePath}>
                        <img src={WhiteSelfServe} alt="self-serve icon"></img>
                    </Link>
                )}
                {!hasAccessToSelfServe && (
                    <div className="sidebar-link-image greyed">
                        <img src={WhiteSelfServe} alt="self-serve icon"></img>
                    </div>
                )}
                {hasAnyDashboard && (
                    <Link className="sidebar-link-image" to={dashboardPath}>
                        <img src={dashboard} alt="dashboard icon"></img>
                    </Link>
                )}
                {!hasAnyDashboard && (
                    <div className="sidebar-link-image greyed">
                        <img src={dashboard} alt="dashboard icon"></img>
                    </div>
                )}
                <div className="bottom-sidebar">
                    <div className="sidebar-link-image">
                        <Notifications
                            setDisplay={setDisplay}
                            flashMessages={flashMessages}
                            messages={messages}
                            onDismiss={onDismiss}
                            onDismissAll={onDismissAll}
                            onDismissFlash={onDismissFlash}
                        />
                    </div>
                    <Link className="sidebar-link-image greyed" to="/:estate/user-profile">
                        <img src={userProfile} alt="user profile icon"></img>
                    </Link>
                </div>
            </div>
            {display && (
                <div className="sidebar-names">
                    <div className="top-sidebar-names">
                        <Link className="sidebar-link-name" to={estateListPath}>
                            <p>{t('stores')}</p>
                        </Link>
                        <Link className="sidebar-link-name" to={contentPath}>
                            <p>{t('channels')}</p>
                        </Link>
                        <Link className="sidebar-link-name" to={mediaPath}>
                            <p>{t('media')}</p>
                        </Link>
                        {hasAccessToSelfServe && (
                            <Link className="sidebar-link-name" to={selfServePath}>
                                <p>{t('self-serve')}</p>
                            </Link>
                        )}
                        {!hasAccessToSelfServe && (
                            <div className="sidebar-link-name greyed">
                                <p>{t('self-serve')}</p>
                            </div>
                        )}
                        {hasAnyDashboard && (
                            <Link className="sidebar-link-name" to={dashboardPath}>
                                <p>{t('reports')}</p>
                            </Link>
                        )}
                        {!hasAnyDashboard && (
                            <div className="sidebar-link-name greyed">
                                <p>{t('reports')}</p>
                            </div>
                        )}
                    </div>
                    <div className="bottom-sidebar-names">
                        <Link className="sidebar-link-name greyed" to="/:estate/user-profile">
                            <p>User Profile</p>
                        </Link>
                    </div>
                </div>
            )}
        </Bar>
    )
}

SideBar.propTypes = {
    flashMessages: PropTypes.arrayOf(PropTypes.shape({})),
    fullscreen: PropTypes.bool,
    messages: PropTypes.arrayOf(PropTypes.shape({})),
    onDismiss: PropTypes.func.isRequired,
    onDismissAll: PropTypes.func.isRequired,
    onDismissFlash: PropTypes.func.isRequired,
}

SideBar.defaultProps = {
    flashMessages: [],
    fullscreen: false,
    messages: [],
}

export default SideBar
